import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "h-screen flex flex-col items-center justify-center mx-4" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-primary font-bold text-xl" }, "Setup process single vault", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "text-primary mx-4" }, "To set up the single vault, please click the button below.", -1);
const _hoisted_4 = { class: "mr-4 mb-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_card = _resolveComponent("card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_card, {
            width: "32",
            heigth: "32",
            class: "container flex flex-row flex-wrap"
        }, {
            header: _withCtx(() => [
                _hoisted_2
            ]),
            default: _withCtx(() => [
                _hoisted_3
            ]),
            actions: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                        class: "flex flex-row justify-center bg-primary text-white capitalize",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => ($setup.proceedToSingleVaultSetup && $setup.proceedToSingleVaultSetup(...args)))
                    }, "Setup")
                ])
            ]),
            _: 1
        })
    ]));
}
